export enum ToastSeverity {
  SUCCESS,
  FAILURE,
  WARNING,
  INFO,
}
